import { useState, useCallback, useEffect, useRef } from 'react';

export const useNotifications = (timeout = 10000) => {
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationTitle, setNotificationTitle] = useState('');
  const [notificationIcon, setNotificationIcon] = useState(null);
  const [notificationIconColor, setNotificationIconColor] = useState(null);
  const [notificationAction, setNotificationAction] = useState(null);

  const timeoutRef = useRef(null);

  const clearNotification = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setNotificationMessage('');
    setNotificationTitle('');
    setNotificationIcon(null);
    setNotificationIconColor(null);
    setNotificationAction(null);
  }, []);

  const showNotification = useCallback(
    (title, message, icon = null, iconColor = null, action = null) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      setNotificationTitle(title);
      setNotificationMessage(message);
      setNotificationIcon(icon);
      setNotificationIconColor(iconColor);
      setNotificationAction(action);

      if (!action) {
        timeoutRef.current = setTimeout(() => {
          setNotificationMessage('');
          setNotificationTitle('');
          setNotificationIcon(null);
          setNotificationIconColor(null);
          setNotificationAction(null);
        }, timeout);
      }
    },
    [timeout],
  );

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  return {
    notificationMessage,
    notificationTitle,
    notificationIcon,
    notificationIconColor,
    notificationAction,
    showNotification,
    clearNotification,
  };
};
